<app-multiple-select-filter (focussedEvent)="focussed()" [elements]="filteredElements"
                            [filterElementProcessor]="filter"
                            [parentFormControlName]="parentFormControlName"
                            [parentFormGroup]="parentFormGroup"
                            [loading]="loading"
                            (selectionChangedEvent)="selectionChanged($event)">
    <ng-template let-element='element' template-content>
        {{element}}
    </ng-template>
</app-multiple-select-filter>
